import React, { useEffect, Suspense } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "@/components/partials/header";
import Sidebar from "@/components/partials/sidebar";
import Settings from "@/components/partials/settings";
import useWidth from "@/hooks/useWidth";
import useMenulayout from "@/hooks/useMenulayout";
import useMenuHidden from "@/hooks/useMenuHidden";
import Footer from "@/components/partials/footer";
import Breadcrumbs from "@/components/ui/Breadcrumbs";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import Loading from "@/components/Loading";
import { motion } from "framer-motion";
const Layout = () => {
  const { width, breakpoints } = useWidth();
  const navigate = useNavigate();
  const { isAuth, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuth || !user) {
      navigate("/");
    }
  }, [isAuth, navigate]);
  const [menuType] = useMenulayout();
  const [menuHidden] = useMenuHidden();
  const location = useLocation();

  return (
    <>
      <ToastContainer />
      <Header />
      <Sidebar />
      <Settings />
      
      {/* Modern 2025 Layout - Responsive with Compact Sidebar */}
      <div className="ml-[80px] pt-16">
        <Suspense fallback={<Loading />}>
          <motion.div
            key={location.pathname}
            initial="pageInitial"
            animate="pageAnimate"
            exit="pageExit"
            variants={{
              pageInitial: {
                opacity: 0,
                y: 20,
              },
              pageAnimate: {
                opacity: 1,
                y: 0,
              },
              pageExit: {
                opacity: 0,
                y: -20,
              },
            }}
            transition={{
              type: "spring",
              damping: 25,
              stiffness: 200,
              duration: 0.3,
            }}
            className="min-h-screen bg-gradient-to-br from-slate-50/30 via-white to-blue-50/20 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900"
          >
            <div className="p-6">
              <div className="mb-6">
                <Breadcrumbs />
              </div>
              <Outlet />
            </div>
          </motion.div>
        </Suspense>
      </div>
      
      {width > breakpoints.md && (
        <Footer />
      )}
    </>
  );
};

export default Layout;
